import { createSelector } from '@ngrx/store';
import { creditCardsState } from '../root';

export const getCardsState = createSelector(creditCardsState, (creditCards) => creditCards);
